/**
 * mwApp.streams module <br>
 * Work with category sets, categories and subcategories: show/add/edit/remove
 *
 * @namespace mwApp/streams
 */

/**
 * ConfigRoutes
 * Configurates module routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/streams
 * @see mwApp/sets
 *
 * @ngdoc config
 * @name mwApp/streams.config:ConfigRoutes
 */
/* @ngInject */
export default function ConfigRoutes ($stateProvider) {
  $stateProvider

    /**
     * abstract state for /streams
     */
    .state('app.streams', {
      abstract: true,
      url: '/streams',
      template: '<ui-view/>'
    })

    .state('app.streams.setrixServerSettings', {
      url: '/setrix-server-settings',
      templateUrl: 'components/packages/views/addPackage.setrixServerSettings.html',
      controller: 'SetrixServerSettingsCtrl as vm',
      label: 'Setrix Server Settings',
      access: 'viewSetrixSettings',
      resolve: {
        scope: ['$state', 'authSvc', function ($state, authSvc) {
          if (!authSvc.hasEnabledFlag('FEATURE_SETRIX_INTEGRATION_ENABLED')) {
            return $state.go('app.404')
          }
          return { featureEnabled: true }
        }]
      }
    })

    .state('app.streams.transcodingStatus', {
      url: '/transcoding-status',
      templateUrl: 'components/streams/views/transcodingStatus.html',
      controller: 'TranscodingStatusCtrl as vm',
      label: 'Transcoding Status',
      access: 'viewSetrixSettings',
      resolve: {
        scope: ['$state', 'authSvc', function ($state, authSvc) {
          if (!authSvc.hasEnabledFlag('FEATURE_SETRIX_INTEGRATION_ENABLED')) {
            return $state.go('app.404')
          }
          return { featureEnabled: true }
        }]
      }
    })

    /**
     * abstract state for /streams
     */
    .state('app.streams.settings', {
      abstract: true,
      url: '/settings',
      template: '<ui-view/>',
      resolve: {
        scope: ['$state', 'authSvc', function ($state, authSvc) {
          if (!authSvc.hasEnabledFlag('FEATURE_STREAM_SERVICES_ENABLED')) {
            return $state.go('app.404')
          }
          // use object 'scope' to share object between different views
          return {
            featureEnabled: true
          }
        }]
      }
    })

  /**
   * controller {@link mwApp/streams.controller:StreamsCtrl}
   * @name /devices
   * @memberof mwApp/streams.config:ConfigRoutes
   */
    .state('app.streams.settings.list', {
      url: '',
      templateUrl: 'components/streams/views/streams.html',
      controller: 'StreamsCtrl as vm',
      label: 'Stream Settings',
      access: 'viewStreamService'
    })

    /**
     * abstract state for /settings
     */
    .state('app.streams.urlPolicies', {
      abstract: true,
      url: '/url-policies',
      template: '<ui-view/>'
    })

    /**
     * abstract state for /settings
     */
    .state('app.streams.urlPolicies.list', {
      url: '',
      templateUrl: 'components/streams/views/urlPolicies.html',
      controller: 'URLPoliciesCtrl as vm',
      label: 'Streaming URL Policy',
      resolve: {
        // defaultPolicy: /* @ngInject */ function (UrlPolicy) {
        //   return UrlPolicy.load({ id: 'default' })
        // }
      },
      access: 'viewUrlPolicy createUrlPolicy editUrlPolicy deleteUrlPolicy | | |'
    })

    /**
     * controller {@link mwApp/streams.controller:AddURLPolicyCtrl}
     * @name /streams/url-policies/:urlPolicyId
     * @memberof mwApp/streams.config:ConfigRoutes
     */
    .state('app.streams.urlPolicies.urlPolicy', {
      url: '/:urlPolicyId',
      templateUrl: 'components/streams/views/addURLPolicy.html',
      controller: 'AddURLPolicyCtrl as vm',
      resolve: {
        urlPolicy: /* @ngInject */ function ($transition$, UrlPolicy) {
          const { urlPolicyId: id } = $transition$.params()
          return id === 'new' ? (new UrlPolicy()) : (UrlPolicy.load({ id }))
        },
        // defaultPolicy: /* @ngInject */ function (UrlPolicy) {
        //   return UrlPolicy.load({ id: 'default' })
        // },
        extra: /* @ngInject */ function (UrlPolicy) {
          return UrlPolicy.loadExtra().then(
            data => {
              data.config = {}
              data.valueDtoList.forEach(property => {
                data.config[property.property] = { operators: property.operators, terms: property.terms, propertyType: property.propertyType }
              })
              return data
            }
          )
        }
      },
      label: '{{::urlPolicyId | addOrEdit}} Streaming URL Policy',
      access: 'viewUrlPolicy createUrlPolicy editUrlPolicy deleteUrlPolicy | | |'
    })
}
